"use strict";
var $ = require("../internals/export");
var uncurryThis = require("../internals/function-uncurry-this");
var notARegExp = require("../internals/not-a-regexp");
var requireObjectCoercible = require("../internals/require-object-coercible");
var toString = require("../internals/to-string");
var correctIsRegExpLogic = require("../internals/correct-is-regexp-logic");
var stringIndexOf = uncurryThis("".indexOf);
$({ target: "String", proto: true, forced: !correctIsRegExpLogic("includes") }, {
  includes: function includes(searchString) {
    return !!~stringIndexOf(
      toString(requireObjectCoercible(this)),
      toString(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : void 0
    );
  }
});
